(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["crystify-collection-links"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('crystify-collection-links')) {
    customElements.define('crystify-collection-links', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.groups = Array.from(this.querySelectorAll('[data-group]'));
        if (!this.groups.length) return;
        this.switches = Array.from(this.querySelectorAll('[data-switch]'));
        this.limit = 7;
        this.expanded = new Set();
        const currentGroup = this.groups.find(group => group.querySelector('[aria-current="page"]'));
        this.active = (currentGroup || this.groups[0]).dataset.group;
        this.media = window.matchMedia('(max-width: 749px)');
        this.controller = new AbortController();
        this.addEventListener('click', event => {
          const button = event.target.closest('button');
          if (!button || !this.contains(button)) return;
          if (button.hasAttribute('data-switch')) {
            this.active = button.dataset.switch;
            this.update();
          } else if (button.hasAttribute('data-more')) {
            const group = button.closest('[data-group]');
            const key = group.dataset.group;
            if (this.expanded.has(key)) this.expanded.delete(key);
            else this.expanded.add(key);
            this.update();
          }
        }, { signal: this.controller.signal });
        // Reveal blocks selected in the theme editor, including collapsed mobile items.
        this.addEventListener('shopify:block:select', event => {
          const item = event.target.closest('[data-item]');
          if (!item || !this.contains(item)) return;
          const group = item.closest('[data-group]');
          this.active = group.dataset.group;
          this.expanded.add(this.active);
          this.update();
        }, { signal: this.controller.signal });
        this.onResize = () => this.update();
        this.media.addEventListener('change', this.onResize);
        this.setAttribute('data-enhanced', '');
        this.update();
      }
      update() {
        const mobile = this.media.matches;
        this.switches.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.switch === this.active)));
        this.groups.forEach(group => {
          const expanded = this.expanded.has(group.dataset.group);
          group.hidden = mobile && group.dataset.group !== this.active;
          const items = Array.from(group.querySelectorAll('[data-item]'));
          items.forEach((item, index) => { item.hidden = !expanded && index >= this.limit; });
          const more = group.querySelector('[data-more]');
          group.querySelector('[data-more-item]').hidden = items.length <= this.limit;
          more.setAttribute('aria-expanded', String(expanded));
          more.querySelector('[data-expand]').hidden = expanded;
          more.querySelector('[data-collapse]').hidden = !expanded;
        });
      }
      disconnectedCallback() {
        if (this.controller) this.controller.abort();
        if (this.media && this.onResize) this.media.removeEventListener('change', this.onResize);
        this.controller = null;
        this.removeAttribute('data-enhanced');
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
